import axios from 'axios'
import { getRestApiConfig } from '../config'
import { ApiCompany } from './types'

export const getCompany = async (ico?: string): Promise<ApiCompany> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(`/api/v1/Companies?ic=${ico}`, restApiConfig.baseUrl).href
    const response = await axios.get<ApiCompany>(endpointUrl, { headers: { ...restApiConfig.authHeader } })
    return response.data
}
